export var OperationStatusContent;
(function (OperationStatusContent) {
    OperationStatusContent["Start"] = "start";
    OperationStatusContent["End"] = "end";
    OperationStatusContent["Pause"] = "pause";
    OperationStatusContent["Continuation"] = "continuation";
})(OperationStatusContent || (OperationStatusContent = {}));
//# sourceMappingURL=OperationStatusContent.js.map